(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskAttachmentAdd',
	};

	var form_id = 'taskattachmentadd-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// initialize Media Hub drag/drop since the form is loaded via AJAX
		if (typeof Adzuki.MediaHubDragDrop !== 'undefined') {
			$('#task-attachments .mh-dragdrop-container').each(function initMediaHubDragDrop() {
				Adzuki.MediaHubDragDrop.init(this);
			});
		}

		// delete an attachment
		$('#task-attachments .delete-attachment-btn').off().on('click', _deleteAttachment);
	};

	form.success = function success(response)
	{
		var task_id = $('#' + form_id + 'task_id').val();

		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		// show success message and re-render the form in the modal on success
		Adzuki.StatusMessage('success', 'The attachment(s) have been saved.', 'Success', {
			onClose: function onAlertClosed() {
				_renderTaskAttachmentsView(task_id);
			}
		});
	};

	function _deleteAttachment(e)
	{
		var $delete_btn   = $(this);
		var attachment_id = $delete_btn.data('attachment-id');
		var task_id       = $('#' + form_id + 'task_id').val();

		e.preventDefault();

		Adzuki.CustomConfirm({
			body   : 'Are you sure you wish to delete this attachment?',
			confirm: function confirmDeletion() {
				var delete_url = '/Tasks/deleteAttachment/' + task_id + '/' + attachment_id;

				Adzuki.Ajax.get(delete_url)
					.then(function taskAttachmentDeleted(response) {
						Adzuki.StatusMessage('success', 'The attachment has been deleted.', 'Success');
						_renderTaskAttachmentsView(task_id);
					});
			},
		});
	}

	/* function _removeAttachment(e)
	{
		var $self = $(this);

		e.stopPropagation();
		e.preventDefault();

		Adzuki.DragDropUpload.removeAttachment($self);
	} */

	function _renderTaskAttachmentsView(task_id)
	{
		var $modal = $('.modal');

		// render attachments view
		Adzuki.Ajax.get('/Tasks/viewTaskAttachments/' + task_id)
			.then(function viewTaskAttachments(response) {
				$modal.find('#task-attachments').html(response);

				Adzuki.Form.initAjaxForm('TaskAttachmentAdd');
			});

		// update the amount of attachments
		Adzuki.Ajax.get('/Tasks/getAttachmentsCount/' + task_id)
			.then(function getAttachmentsCount(response) {
				$('.task-attachments-count').addClass('hidden');

				if (response && response.attachments_count > 0) {
					$('.task-attachments-count')
					.removeClass('hidden')
					.text(response.attachments_count);
				}
			});
	}

	/* function _viewAttachment(e)
	{
		var $self = $(this);

		e.stopPropagation();
		e.preventDefault();

		Adzuki.DragDropUpload.viewAttachment($self, true);
	} */

}(jQuery, window.Adzuki || {}));
